module.exports = __webpack_public_path__ + "img/LMS Aset Illustrasi No Section.eb971d92.png";